export type ID = number
export type UID = string
export type CID = string

export enum PlayableType {
  TRACK = 'track',
  PLAYLIST = 'playlist',
  ALBUM = 'album'
}
